import InfoCardWrapper from "../../InfoCardWrapper";
import cx from "classnames";
import { Trans } from "@lingui/macro";
import s from "./styles.module.scss";
import { useMemo } from "react";

const TotalTradingVolume = ({ item }) => {
  const progressPercent = useMemo(() => Math.floor(Math.random() * 101), []);

  const achieved = 0;
  const progressLabel = `${progressPercent}% (${achieved}) of trading target achieved.`;
  const progressStyle = useMemo(
    () => ({
      width: `${progressPercent}%`,
    }),
    [progressPercent]
  );
  return (
    <InfoCardWrapper>
      <div className={cx("App-card-title", s.title)}>
        {item.isCompleted ? <Trans>Total Trading Volume</Trans> : <Trans>Coming Soon</Trans>}
      </div>
      {item.isCompleted && (
        <>
          <p className={s.description}>
            The allocation of $esTMX tokens to qualified participants will be determined based on the cumulative trading
            volume of TMX achieved Public Open Beta up until 1 September 2023.
          </p>
          <p className={s.description}>
            At $1Bn total trading volume, 2% of the total supply will be allocated. At the base level, which corresponds
            to $0 in trading volume, 0.5% of the total supply will be allocated.
          </p>
        </>
      )}

      {/*<div className={s.progressContainer}>*/}
      {/*  <div className={s.progressTitle}>*/}
      {/*    <span>0.5%</span>*/}
      {/*    <span>2.0%</span>*/}
      {/*  </div>*/}

      {/*  <div className={s.progress}>*/}
      {/*    <div className={s.progressFill} style={progressStyle} />*/}
      {/*  </div>*/}
      {/*  <div className={s.progressLabel}>{progressLabel}</div>*/}
      {/*</div>*/}
    </InfoCardWrapper>
  );
};

export default TotalTradingVolume;
